function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.844532mm",
    height: "5.8723245mm",
    viewBox: "0 0 3.844532 5.8723245",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.248886,-96.589064)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 12.462166,102.36094 q -0.05859,-0.11328 -0.08594,-0.21484 -0.02734,-0.10157 -0.02734,-0.19141 0,-0.40625 0.816406,-1 0.226562,-0.16406 0.351562,-0.25781 0.902344,-0.6836 1.316407,-1.238285 0.417968,-0.554687 0.417968,-1.074218 0,-0.457032 -0.308593,-0.738282 -0.308594,-0.285156 -0.8125,-0.285156 -0.398438,0 -0.683594,0.195313 -0.285156,0.191406 -0.5,0.605468 -0.164063,-0.105468 -0.246094,-0.230468 -0.08203,-0.125 -0.08203,-0.265625 0,-0.402344 0.4375,-0.6875 0.441406,-0.289063 1.097656,-0.289063 0.820313,0 1.328125,0.457031 0.511719,0.457032 0.511719,1.183594 0,0.746094 -0.675781,1.546875 -0.675782,0.800786 -2.144532,1.789066 0.109375,0.004 0.296875,0.008 0.335938,0.008 0.4375,0.008 0.761719,0 1.242188,-0.0664 0.480469,-0.0703 0.726562,-0.21094 0.05078,0.13281 0.07422,0.2539 0.02734,0.11719 0.02734,0.22266 0,0.25781 -0.164063,0.36328 -0.164062,0.10156 -0.601562,0.10156 -0.332031,0 -0.933594,-0.0195 -0.597656,-0.0195 -0.867187,-0.0195 -0.273438,0 -0.507813,0.0156 -0.234375,0.0117 -0.441406,0.0391 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit2);
export default __webpack_public_path__ + "static/media/digit-2.ad1ccfe6d3401264acd24c9c859aa803.svg";
export { ForwardRef as ReactComponent };